import { render, staticRenderFns } from "./SingleDashboardsTable.vue?vue&type=template&id=bd37a75c&scoped=true&"
import script from "./SingleDashboardsTable.vue?vue&type=script&lang=js&"
export * from "./SingleDashboardsTable.vue?vue&type=script&lang=js&"
import style0 from "./SingleDashboardsTable.vue?vue&type=style&index=0&id=bd37a75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd37a75c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
